import { render, staticRenderFns } from "./ManagePayment.vue?vue&type=template&id=6804c190&scoped=true"
import script from "./ManagePayment.vue?vue&type=script&lang=ts"
export * from "./ManagePayment.vue?vue&type=script&lang=ts"
import style0 from "./ManagePayment.vue?vue&type=style&index=0&id=6804c190&prod&scoped=true&lang=css"
import style1 from "./ManagePayment.vue?vue&type=style&index=1&id=6804c190&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804c190",
  null
  
)

export default component.exports